import { render, staticRenderFns } from "./AdminPane.vue?vue&type=template&id=c2bcc7b0&scoped=true&"
import script from "./AdminPane.vue?vue&type=script&lang=js&"
export * from "./AdminPane.vue?vue&type=script&lang=js&"
import style0 from "./AdminPane.vue?vue&type=style&index=0&id=c2bcc7b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bcc7b0",
  null
  
)

export default component.exports